/* eslint-disable react/button-has-type */
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

// Component
import ProviderFilterItem from "components/molecules/ProviderFilterItem";
import InputSearch from "components/atoms/InputSearch";

// Constants
import { SearchFields } from "constants/variables";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useGTM } from "hooks/useGTM";

// Types
import { ProviderType } from "types/Games";
import { FilterType } from "redux/game/slice";

import "./styles.sass";

type ProviderFilterType = {
  providers: ProviderType[] | null;
  filter: FilterType;
  selectedProviders: string[] | null;
  onProviderSelect: (value?: string) => void;
};

const ProviderFilter = (props: ProviderFilterType) => {
  const { setValue, watch } = useFormContext();
  const { providers, filter, selectedProviders, onProviderSelect } = props;
  const t = useTranslate();
  const searchQuery = watch(SearchFields.PROVIDER);
  const GTM = useGTM();

  useEffect(() => {
    if (selectedProviders && selectedProviders.length) {
      providers?.forEach((el) => {
        if (selectedProviders.includes(el.name)) {
          setValue(`provider-check-${el.name}`, true);
        } else {
          setValue(`provider-check-${el.name}`, false);
        }
      });
    } else {
      providers?.forEach((el) => {
        setValue(`provider-check-${el.name}`, false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProviders]);

  const handleProviderClick = (name?: string, value?: boolean) => {
    setValue(`provider-check-${name}`, value);
    onProviderSelect(name);
  };

  const filterProviders = searchQuery
    ? providers?.filter((provider) =>
        provider.name.toLowerCase().startsWith(searchQuery.toLowerCase()),
      )
    : providers;

  return (
    <div className="ProviderFilter">
      <InputSearch
        name={SearchFields.PROVIDER}
        placeholder={t("placeholder.search")}
        gtm={GTM.providerSearchKeyword}
        value=""
      />
      <div className="ProviderFilter__title">
        {t("casino.providers.header")}{" "}
        <button
          className="ProviderFilter__reset"
          onClick={() => onProviderSelect()}
        >
          {t("casino.providers.reset")}
        </button>
      </div>
      <div className="ProviderFilter__providers">
        {filterProviders?.length ? (
          filterProviders?.map((provider) => (
            <ProviderFilterItem
              key={provider.name}
              name={provider.name}
              // count={0}
              active={
                filter.providers
                  ? !!filter.providers.find(
                      (p) => p.toLowerCase() === provider.name.toLowerCase(),
                    )
                  : false
              }
              onClick={handleProviderClick}
            />
          ))
        ) : (
          <div className="ProviderFilter__providers_empty">
            <span>{t("casino.search.error")}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProviderFilter;
